import { Matrix } from '../math';
/**
 * Represents a scaling transformation with separate x and y scaling factors.
 * Provides methods to convert to matrix form and create inverse transformations.
 */
export class Scale {
    /**
     * Creates a new Scale transformation.
     * @param x The scaling factor for the x-axis
     * @param y The scaling factor for the y-axis
     */
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    /**
     * Converts the scaling transformation to a matrix representation.
     * @returns A matrix representing the scaling transformation
     */
    toMatrix() {
        return Matrix.scaling(this.x, this.y);
    }
    /**
     * Returns a string representation of the scaling transformation.
     * @returns String representation in CSS transform format
     */
    toString() {
        return `scale(${this.x},${this.y})`;
    }
    /**
     * Creates an inverted version of this scaling transformation.
     * @returns A new Scale with inverted scaling factors
     */
    invert() {
        return new Scale(1 / this.x, 1 / this.y);
    }
}
;
